import { IconProps } from '@rsuite/icons/lib/Icon'
import { FC } from 'react'

const PlusIcon: FC<IconProps> = ({ className }) => (
  <svg
    className={`plus-icon ${className}`}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="#8E8E93"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <rect
        x="5.25"
        y="0.75"
        width="1.5"
        height="10.5"
        rx="0.75"
      />
      <rect
        x="0.75"
        y="5.25"
        width="10.5"
        height="1.5"
        rx="0.75"
      />
    </g>
  </svg>

)

export default PlusIcon
